import * as React from 'react';

import { BookingInfoConstructor } from 'shared/components/BookingInfoConstructor';

const mockBookingInfo = [
  {
    title: '',
    sections: [
      {
        title: '',
        headLine: {
          text: 'Всего за 3 ночи',
          value: '20 000 ₽',
        },
        lines: [
          {
            text: 'Предоплата картой',
            value: '3 500 ₽',
          },
          {
            text: 'Оплатить на месте',
            value: '16 500 ₽',
          },
          {
            text: '+ Залог (оплачивается отдельно)',
            value: '3 500 ₽',
          },
        ],
      },
    ],
  },
];

// Конструктор информации о брони, на основе blocks[] -> sections[] -> lines[] где большинство полей опциональные.
// Контент полностью контролируется ручкой бека, где формируются разные данные в зависимости от типа брони, пользователя и тд.
// Пример: платежная информация с разбивками на залог и оплату на месте, ндс, информация о гостях, скидках и тд.
export const BookingSummaryContainer = () => {
  const bookingInfo = mockBookingInfo;

  if (!bookingInfo?.length) {
    return null;
  }

  return <BookingInfoConstructor blocks={bookingInfo} />;
};
